import baseStyles from '../Base/Base.styles'
import merge from 'lodash/merge'
import objectFilter from '@converdy/utils/object-filter'
import cCssToJss from '@converdy/styles/c-css-to-jss'

export default ({
  base,
  primaryColor,
}) => {

  let jss = {root: {
    ...baseStyles(base),
    "& button": {}

  } }

  switch (variant) {
    case 'solid': {

      if(textColor) {
        jss.root['& button']['--text-color'] = textColor  
      }

      if(primaryColor) {
        jss.root['& button']['--primary-color'] = primaryColor  
      }
    }
    break
     case 'outlined': {

      if(primaryColor) {
        jss.root['& button']['--primary-color'] = primaryColor  
      }

    }
     break
     case 'underlined': {

      if(primaryColor) {
        jss.root['& button']['--primary-color'] = primaryColor  
      }

     }
     
    }


  return jss
}